(() => {
  'use strict';

  if (window.PWProductSummaryEanLoaded) return;
  window.PWProductSummaryEanLoaded = true;

  const productRequests = new Map();

  const getProductData = () => {
    const path = window.location.pathname.replace(/\/+$/, '');
    if (!/\/products\//.test(path)) return Promise.resolve(null);

    const url = `${path}.js`;
    if (!productRequests.has(url)) {
      productRequests.set(
        url,
        fetch(url, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Productgegevens konden niet worden geladen (${response.status})`);
            return response.json();
          })
          .catch(() => null)
      );
    }

    return productRequests.get(url);
  };

  const currentVariantId = (page) => {
    const picker = page.querySelector('[data-pw-variant-picker]');
    if (picker instanceof HTMLSelectElement && picker.value) return String(picker.value);

    const hiddenVariant = page.querySelector('form.pw-product-form input[name="id"]');
    return hiddenVariant instanceof HTMLInputElement ? String(hiddenVariant.value || '') : '';
  };

  const ensureEanRow = (summary) => {
    let row = summary.querySelector('[data-pw-product-ean]');
    if (row) return row;

    row = document.createElement('p');
    row.className = 'pw-product-reference pw-product-reference--ean';
    row.dataset.pwProductEan = '';
    row.hidden = true;
    row.setAttribute('aria-hidden', 'true');

    const label = document.createElement('span');
    label.textContent = 'EAN ';

    const value = document.createElement('span');
    value.dataset.pwProductEanValue = '';

    row.append(label, value);

    const header = summary.querySelector(':scope > .pw-product-hero__header');
    if (!header) return row;

    const references = header.querySelectorAll('.pw-product-reference');
    const lastReference = references.length ? references[references.length - 1] : null;
    const title = header.querySelector('.pw-product-title');

    if (lastReference) lastReference.insertAdjacentElement('afterend', row);
    else if (title) title.insertAdjacentElement('afterend', row);
    else header.append(row);

    return row;
  };

  const enhancePage = async (page) => {
    if (!(page instanceof Element)) return;

    const summary = page.querySelector('.pw-product-hero__summary');
    if (!summary) return;

    const row = ensureEanRow(summary);
    const value = row.querySelector('[data-pw-product-ean-value]');
    if (!value) return;

    const product = await getProductData();
    const variants = Array.isArray(product && product.variants) ? product.variants : [];
    const barcodeByVariant = new Map(
      variants.map((variant) => [String(variant.id), String(variant.barcode || '').trim()])
    );

    const sync = () => {
      const barcode = barcodeByVariant.get(currentVariantId(page)) || '';
      value.textContent = barcode;
      row.hidden = !barcode;
      row.setAttribute('aria-hidden', barcode ? 'false' : 'true');
    };

    sync();

    const picker = page.querySelector('[data-pw-variant-picker]');
    if (picker && picker.dataset.pwEanBound !== 'true') {
      picker.dataset.pwEanBound = 'true';
      picker.addEventListener('change', sync);
    }

    page.addEventListener('variant:change', sync);
    page.addEventListener('product:variant-change', sync);
  };

  const init = (root = document) => {
    if (root instanceof Element && root.matches('.pw-product-page')) enhancePage(root);
    root.querySelectorAll('.pw-product-page').forEach(enhancePage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('.pw-product-hero__summary') || node.querySelector('.pw-product-hero__summary')) {
          init(document);
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
